import React, { useEffect, useState } from 'react';
import useGlobal from '../../store';
import {
	zoneById,
	getZoneEquipment,
	getZoneSpaces,
	updateZone,
	getZoneNotes,
	addZoneNote,
	getZoneSchedules,
	getAllSchedules,
	linkScheduleToEntity,
	removeZoneSpace,
	getSiteSpaces,
	addZoneSpace
} from '../../services/MetadataService';

import LoadedEquipmentList from '../../loaded/LoadedEquipmentList';
import SpaceList from '../../components/SpaceList';
import ScheduleView from '../../components/Schedule';

import { ModeEdit, Settings } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useConfirm } from 'material-ui-confirm';

import Notes from '../../components/Notes'
import { getBrickZoneTypes, getPNNLZoneTypes } from '../../services/DimensionsServices';
import { IconButton, TextField, Autocomplete } from '@mui/material';
import { LoadingButton } from '@mui/lab'

import LoadedControls from '../../loaded/LoadedControls';

//TODO: Move edit stuff to own component
const ShowZone = (props) => {
	const [zone, setZone] = useState();
	const [spaces, setSpaces] = useState();
	const [equipment, setEquipment] = useState();
	const [notes, setNotes] = useState();
	const [schedules, setSchedules] = useState();
	const [siteId, setSiteId] = useState();

	const[brickTypes, setBrickTypes] = useState([]);
	const[pnnlTypes, setPnnlTypes] = useState([]);

	const[allSchedules, setAllSchedules] = useState([]);
	const[siteSpaces, setSiteSpaces] = useState([]);

	const[editMode, setEditMode] = useState(false)
	const[error, setError] = useState()
	let [currentState, currentActions] = useGlobal();
	let history = useHistory();

	const [isSubmitting, setIsSubmitting] = useState(false)

	let [currentUser, setCurrentUser] = useState()
	const confirm = useConfirm();

	useEffect(() => {
		let zoneId = props && props.zoneId;
		if (!zone) {
			zoneById(zoneId).then((response) => {
				setZone(response);
			});
		}

		getEquipment(zoneId);
		getSpaces(zoneId);

		getZoneNotes(zoneId).then(response => {
			setNotes(response)
		})

		getZoneSchedules(zoneId).then(response => {
			setSchedules(response)
		})

		getBrickZoneTypes().then(response => {
			setBrickTypes(response)
		});

		getPNNLZoneTypes().then(response => {
			setPnnlTypes(response)
		})

		getAllSchedules().then(response => {
			setAllSchedules(response)
		})

		// if (!currentUser) {
        //     Auth.currentUserInfo().then(response => {
        //         setCurrentUser(response.attributes.name)
        //     })
        // }
	}, [])

	const getEquipment = (zoneId) => {
		getZoneEquipment(zoneId).then((response) => {
			setEquipment(response);
		});
	};

	const getSpaces = (zoneId) => {
		getZoneSpaces(zoneId).then((response) => {
			setSpaces(response);
			let site_id = response[0].site_id
			setSiteId(site_id)
			getSiteSpaces(site_id).then((site_response) => {
				setSiteSpaces(site_response)
			})
		});
	};

	const setName = (value) => {
			let currentZone = Object.assign({}, zone);
			currentZone.name = value
			setZone(currentZone)
	}

	const submitChanges = () => {
		setIsSubmitting(true)
		updateZone(zone).then(response => {
			setZone(response)
			setEditMode(false)
			setIsSubmitting(false)
		}).catch(error => {
			console.log(error)
			setError("There was an error updating the zone.")
		});
	}

	const addNote = async (note) => {
		note.author = currentUser;
		addZoneNote(zone.id, note).then(() => {
			getZoneNotes(zone.id).then(response => {
				setNotes(response)
			})
		}).catch(err => {
			console.log(err)
		})

	}

	const linkSchedule = async (schedule) => {
		linkScheduleToEntity("zones", zone.id, schedule).then(response => {
			getZoneSchedules(zone.id).then(response => {
				setSchedules(response);
			})
		})
	}

	const removeFromZone = (space) => {
		confirm({ 
			title: "Remove space from zone?",
			description: 'This action removes the space from the current zone.  It does not delete the space itself.' 
		})
		.then(() => { 
			removeZoneSpace(zone.id, space).then(response => {
				setZone(response)
				setSpaces(response.spaces)
			})
		})
		.catch(() => {console.log("User cancelled action") });
	}

	const addToZone = async (spaces) => {
		spaces.forEach(space => {
			addZoneSpace(zone.id, space).then(response => {
				setZone(response)
				setSpaces(response.spaces)
				return true;
			})
		})
	}

	useEffect(() => {
		if (zone) {
			currentActions.setZone(zone);
		}
	}, [zone]);

	let defaultType = zone && zone.brick_zone_type ? brickTypes.find(t => t.brick_zone_type === zone.brick_zone_type) : null
	let defaultPnnlType = zone && zone.pnnl_zone_type ? pnnlTypes.find(t => t.name === zone.pnnl_zone_type) : null

  	return (
    <div className="layer3">
		<LoadedControls siteId={siteId} equipmentList={equipment} />
      	<div className="location">
      	{  zone ?
		<div className="space-stats">
			<div className="section-header">
				Stats
				<div className="edit-element">
					<IconButton 
								variant="contained" 
								color="primary"
								aria-label={"Edit these values" }

								onClick={() => {
									setEditMode(true)
							}}>
							<ModeEdit style={{fill: "#00b088", background: "white", transform: "scale(0.8)"}}/>
					</IconButton>
					<IconButton 
								variant="contained" 
								color="primary"
								aria-label={"View and edit zone configuration" }

								onClick={() => {
									history.push("/variables/zone/" + zone.id)
							}}>
								<Settings style={{fill: "#003e51", background: "white", transform: "scale(0.8)"}}/>
					</IconButton>
				</div>
			</div>
			<div className="stats-container">
				{
					editMode ?
					<div className="stat-edit">
						<TextField label="Zone Name" defaultValue={zone.name} variant="outlined" size="small" onChange={(e) => {setName(e.target.value)}}/> 
					</div>
					:
					null
				}

				{
					editMode ?
					<div className="stat-edit">
						<Autocomplete
							disablePortal
							id="Type"
							options={brickTypes}
							getOptionLabel={option => option.name}
							defaultValue={defaultType}
							renderInput={(params) => <TextField {...params} label="Type" variant="outlined" fullWidth size="small" />}
							style={{ width: "200px" }}
							size={"small"}
							groupBy={(option) => option.parent}
							onChange={(event, newValue) => {
								let currentZone = Object.assign({}, zone);
								currentZone.brick_zone_type = newValue.brick_zone_type
								setZone(currentZone)
							}}
						/>
					</div>
					:

					<div className="stat">
						<div className="stat-label">Type</div>
						{defaultType ? 
							<div className="stat-value">{defaultType.name}</div> :
							<div className="stat-unavailable">Add value</div> }
					</div>
				}

				{/* I may remove the PNNL zone type.  They are confusing and not sure they buy us much. {
					editMode ?
					<div className="stat-edit">
						<Autocomplete
							disablePortal
							id="Type"
							options={pnnlTypes}
							defaultValue={defaultPnnlType}
							getOptionLabel={option => option.name}
							renderInput={(params) => <TextField {...params} label="PNNL Classification" variant="outlined" fullWidth size={"small"} />}
							style={{ width: "200px" }}
							size={"small"}
							onChange={(event, newValue) => {
								let currentZone = Object.assign({}, zone);
								currentZone.pnnl_zone_type = newValue.name
								setZone(currentZone)
							}}
						/>
					</div>
					:

					<div className="stat">
						<div className="stat-label">PNNL Classification</div>
						{defaultPnnlType ? 
							<div className="stat-value">{defaultPnnlType.name}</div> :
							<div className="stat-unavailable">Add value</div> }
					</div>
				} */}

				{
					editMode ?
					<div className="stat">
						<LoadingButton
                            variant="contained"
                            loading={isSubmitting}
							onClick={submitChanges}
                            type="submit"
                            sx={{backgroundColor: "#003e51"}}>
                                Submit
                        </LoadingButton>
					</div>
					:
					null
				}
			</div>
		</div>
		: null }
		<SpaceList spaces={spaces} removeFromZoneCallback={removeFromZone} addToZoneCallback={addToZone} allSpaces={siteSpaces} />
        <LoadedEquipmentList equipment={equipment} siteId={siteId} zoneId={props.zoneId}/>
		<Notes notes={notes} onSubmit={addNote} />
		<ScheduleView header="Schedules" schedules={schedules} viewMode="week" linkToEntity={linkSchedule} allSchedules={allSchedules} /> 
      </div>
    </div>
  );
};

export default ShowZone;
